/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetBackContabilitaRicercaFornitoriParams,
  RicercaFornitoreResponse,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * @summary Ricerca Fornitori
 */
export const getBackContabilitaRicercaFornitori = (
  params?: GetBackContabilitaRicercaFornitoriParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<RicercaFornitoreResponse>(
    {
      url: `/framework-bo-procedimenti/contabilita/ricercaFornitori`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackContabilitaRicercaFornitoriQueryKey = (
  params?: GetBackContabilitaRicercaFornitoriParams,
) =>
  [
    `/framework-bo-procedimenti/contabilita/ricercaFornitori`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackContabilitaRicercaFornitoriQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackContabilitaRicercaFornitoriParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackContabilitaRicercaFornitoriQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>
  > = ({ signal }) =>
    getBackContabilitaRicercaFornitori(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackContabilitaRicercaFornitoriQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>
>;
export type GetBackContabilitaRicercaFornitoriQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca Fornitori
 */
export const useGetBackContabilitaRicercaFornitori = <
  TData = Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackContabilitaRicercaFornitoriParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackContabilitaRicercaFornitori>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackContabilitaRicercaFornitoriQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
